"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const StyledListItem = (0, material_1.styled)(material_1.ListItemButton)((theme) => ({
    root: {
        "&$selected": {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            backgroundColor: theme.palette?.advancedSearchFilterListItem?.color,
            "&:hover": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                backgroundColor: theme.palette?.advancedSearchFilterListItem?.color,
            },
        },
    },
}));
const StyledList = (0, material_1.styled)(material_1.List)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
}));
const StyledListSection = (0, material_1.styled)("li")(({ theme }) => ({
    backgroundColor: "inherit",
}));
const StyledUL = (0, material_1.styled)("ul")(({ theme }) => ({
    backgroundColor: "inherit",
    padding: 0,
}));
const StyledSubHeader = (0, material_1.styled)(material_1.ListSubheader)(({ theme }) => ({
    textTransform: "uppercase",
    lineHeight: "25px",
    marginTop: "25px",
}));
const StyledCategoryHeaders = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    fontWeight: "bold",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
    color: theme.palette.advancedSearchFilterListCategoryHeader?.color,
}));
const StyledFilterCountLabel = (0, material_1.styled)("span")(({ theme }) => ({
    paddingLeft: theme.spacing(5),
}));
const SelectableList = ({ items, sections = [], onChange, selectedItemId, deleteSavedSearch, objectType, }) => {
    const [selectedId, setSelectedId] = (0, react_1.useState)(selectedItemId);
    const handleListItemClick = (event, id) => {
        setSelectedId(id);
        onChange(id);
    };
    const handleDeleteSavedSearch = (event, id) => {
        event.stopPropagation();
        deleteSavedSearch(id, objectType);
    };
    return (react_1.default.createElement(StyledList, { dense: true, subheader: react_1.default.createElement("li", null), "data-testid": "SelectableList_root" },
        sections.map(({ id: sectionId, name: sectionName }) => (react_1.default.createElement(StyledListSection, { key: `section-${sectionId}`, "data-testid": `SelectableList_section_header_${sectionId}` },
            react_1.default.createElement(StyledUL, null,
                react_1.default.createElement(StyledSubHeader, null,
                    react_1.default.createElement(StyledCategoryHeaders, null, sectionName)),
                items
                    .filter(({ sectionId: id }) => sectionId === id)
                    .map(({ name: itemName, id: itemId }) => (react_1.default.createElement(StyledListItem, { selected: itemId === selectedId, key: `item-${itemId}`, onClick: (event) => handleListItemClick(event, itemId), "data-testid": `selectableList_items_by_section_${itemId}` },
                    react_1.default.createElement(material_1.ListItemText, { primary: itemName })))))))),
        items
            .filter(({ sectionId }) => !sectionId)
            .map(({ name: itemName, id: itemId, viewableByAll, type, filters }) => (react_1.default.createElement(StyledListItem, { selected: itemId === selectedId, key: `item-${itemId}`, onClick: (event) => handleListItemClick(event, itemId), "data-testid": itemId },
            react_1.default.createElement(material_1.ListItemText, { primary: itemName }),
            type === "savedSearch" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.ListItemSecondaryAction, null,
                    viewableByAll ? "All users" : "Just me",
                    react_1.default.createElement(StyledFilterCountLabel, null, `${filters?.length || 0} filter(s)`),
                    react_1.default.createElement(material_1.IconButton, { "data-testid": `${itemId}_delete`, "aria-label": "delete", onClick: (event) => handleDeleteSavedSearch(event, itemId) },
                        react_1.default.createElement(Delete_1.default, null))))))))));
};
exports.default = SelectableList;
